// Runtime overrides are arguments/flags passed in as a query parameter.
// The structure is a JSON object encoded via encodeURIComponent.
// Example: ?runtimeOverrides=%7B%22fileSystemId%22%3A%22...%22%7D

export const RUNTIME_OVERRIDE_KEY = 'runtimeOverrides';

const parseProps = (props: string, values: Record<string, unknown> = {}) => {
  try {
    const decoded = decodeURIComponent(props);
    const parsed = JSON.parse(decoded) as Record<string, unknown>;
    return { ...values, ...parsed };
  } catch {
    return values;
  }
};

/**
 * Parse runtime overrides from a query string (and session storage when present).
 * Used at module init and in tests.
 */
export function getRuntimeOverrides(searchString: string): Record<string, unknown> {
  let bag: Record<string, unknown> = parseProps(
    `${typeof sessionStorage !== 'undefined' ? sessionStorage.getItem(RUNTIME_OVERRIDE_KEY) : ''}`
  );
  const search = new URLSearchParams(searchString);
  if (search.has(RUNTIME_OVERRIDE_KEY)) {
    bag = parseProps(`${search.get(RUNTIME_OVERRIDE_KEY)}`, bag);
  }
  return bag;
}

function loadOverrideBag(): Record<string, unknown> {
  if (typeof window === 'undefined') {
    return {};
  }
  return getRuntimeOverrides(window.location.search.slice(1));
}

const overrideBag: Record<string, unknown> = loadOverrideBag();

/** Full parsed bag for child-window query propagation — not for curated reads. */
export function getOverrideBagForPropagation(): Readonly<Record<string, unknown>> {
  return overrideBag;
}

export function getOverrideBag(): Record<string, unknown> {
  return overrideBag;
}
